import * as React from 'react';
import CalendarUpdatesSection from './CalendarUpdatesSection';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import ShareACalendarSection from './ShareACalendarSection';
import { observer } from 'mobx-react';
/**
 * Wrapper component for rendering the calendar sharing settings UI.
 */
export default observer(function SharedCalendarsFull() {
    return (React.createElement("div", null,
        React.createElement(ShareACalendarSection, null),
        isConsumer() && React.createElement(CalendarUpdatesSection, null)));
});
//# sourceMappingURL=SharedCalendarsFull.js.map